export default function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-collection/src/entries.js
// module id = 1651
// module chunks = 3